<template>
  <div v-if="isConnect">
    <div v-if="isEE">
      <v-divider class="mt-6 mb-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" md="7" lg="5" class="py-0 pt-5">
            <span class="custom-title">OVC Specification</span>
          </v-col>
        </v-row>
      </ValidationObserver>
      <v-divider class="mt-6 mb-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Route Type"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="routeType"
                :items="routeType"
                label="Route Type"
                outlined
                placeholder=" "
                :clearable="true"
                v-model="nbnOrder.routeType"
                :error-messages="errors"
                dense
                :readonly="false"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="NNI Group Id"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-text-field
                ref="nniGroupId"
                v-model="nbnOrder.nniGroupId"
                label="NNI Group Id"
                placeholder=" "
                outlined
                dense
                :readonly="false"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Cos High Bandwidth"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="cosHighBandwidth"
                :items="COS_HIGH_BANDWIDTH"
                label="Cos High Bandwidth"
                outlined
                placeholder=" "
                :clearable="true"
                v-model="nbnOrder.cosHighBandwidth"
                :error-messages="errors"
                dense
                :readonly="false"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Mapping Mode"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="mappingMode"
                :items="mappingMode"
                label="Mapping Mode"
                outlined
                placeholder=" "
                :clearable="true"
                v-model="nbnOrder.mappingMode"
                :error-messages="errors"
                dense
                :readonly="false"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="OVC Transient Id"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="ovcTransientId"
                :items="OVC_TRANSIENT_ID"
                label="OVC Transient Id"
                outlined
                placeholder=" "
                :clearable="true"
                v-model="nbnOrder.ovcTransientId"
                :error-messages="errors"
                dense
                :readonly="false"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
        </v-row>
      </ValidationObserver>
    </div>

    <div v-if="!isEE">
      <v-divider class="mt-6 mb-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" md="7" lg="5" class="py-0 pt-5">
            <span class="custom-title">AVCD Specification</span>
          </v-col>
        </v-row>
      </ValidationObserver>
      <v-divider class="mt-6 mb-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col v-if="showContractTerm" cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Contract Term"
              :rules="showContractTerm ? 'required' : ''"
              v-slot="{ errors }"
            >
              <v-select
                ref="contractTerm"
                :items="contractTerm"
                label="Contract Term"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.contractTerm"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
                :disabled="isPendingServiceability"
              ></v-select>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Bandwidth Profile"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-select
                ref="getBandwidth"
                :items="getBandwidth"
                label="Bandwidth Profile"
                item-text="text"
                item-value="value"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.bandwidthProfile"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
                :disabled="isPendingServiceability"
              >
                <template v-slot:item="data">
                  <v-list-item
                    v-bind="data.attrs"
                    v-on="data.on"
                    :disabled="data.item.disabled"
                    v-show="!isOriginal && !data.item.obsolete"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        :class="{
                          'text--disabled': data.item.disabled,
                          'font-italic': data.item.disabled,
                        }"
                      >
                        {{ data.item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { NFASBandwidthProfile } from "../../constants";
import {
  NBN_ASSURE_ALLOWED_SPEED,
  COS_HIGH_BANDWIDTH,
  OVC_TRANSIENT_ID,
  BANDWIDTH_PROFILES,
  CONTRACT_TERMS,
  getFTTCBandwidthProfiles
} from "../../constants/nbn-edit-form-constants";
import { wholesalerUsesContractTerm } from "../../utils/wholesaler";
export default {
  name: "nbn-realized-service",
  props: {
    productType: { type: String },
    isConnect: { type: Boolean },
    CsaId: { type: String },
    wholesalerAccount: { type: Number }
  },
  data: () => ({
    routeType: [
      { text: "Local", value: "Local", disabled: false },
      { text: "State", value: "State", disabled: false }
    ],
    contractTerm: CONTRACT_TERMS,
    mappingMode: [
      { text: "DSCP", value: "DSCP", disabled: false },
      { text: "PCP", value: "PCP", disabled: false }
    ],
    tpep: [
      {
        text: "Transport Protocol and Web Page Optimisation ON",
        value: "Transport Protocol and Web Page Optimisation ON",
        disabled: false
      },
      {
        text: "Transport Protocol Only ON",
        value: "Transport Protocol Only ON",
        disabled: false
      },
      {
        text: "Transport Protocol and Web Page Optimisation OFF",
        value: "Transport Protocol and Web Page Optimisation OFF",
        disabled: false
      }
    ],
    NCASBandwidthProfile: BANDWIDTH_PROFILES.NCAS,
    NWASBandwidthProfile: BANDWIDTH_PROFILES.NWAS,
    NHASBandwidthProfile: BANDWIDTH_PROFILES.NHAS,
    FibreBandwidthProfile: BANDWIDTH_PROFILES.NFAS,
    NFASBandwidthProfile: NFASBandwidthProfile,
    AssureBandwidthProfile: NBN_ASSURE_ALLOWED_SPEED
  }),
  methods: {
    emitData() {
      let vm = this;
      vm.$emit("emitNbnRealizedService", vm.nbnOrder);
    },
    resetForm() {
      let vm = this;
      if (vm.isEE) {
        vm.$refs.routeType.reset();
        vm.$refs.nniGroupId.reset();
        vm.$refs.cosHighBandwidth.reset();
        vm.$refs.mappingMode.reset();
        vm.$refs.ovcTransientId.reset();
      } else {
        if (vm.$refs.contractTerm) {
          vm.$refs.contractTerm.reset();
        }
        vm.$refs.getBandwidth.reset();
      }
    },
    getBandwidthFibreIncludingThreshold(bandwidth) {
      let bandwidthArray = [...bandwidth];
      let vm = this;
      try {
        if (vm.sqNbnResult.sq) {
          let selectedNTD = vm.sqNbnResult.sq?.siteRestriction?.supportingResource?.find(
            x => x.id === vm.nbnOrder.ntdId
          );
          if (
            selectedNTD != null &&
            vm.nbnOrder.ntdModifications !== "REPLACE SELECTED NTD" &&
            vm.nbnOrder.ntdModifications !== "REQUEST NEW NTD"
          ) {
            if (vm.nbnOrder.orderType?.toLowerCase() === "transfer" && vm.featureFlags?.sog8737) {
              return bandwidthArray;
            }

            let remainingCapacity = selectedNTD.ntdDetails.find(
              x => x.name == "Remaining Capacity Downstream"
            )?.rawValue;

            if (remainingCapacity) {
              bandwidthArray = bandwidthArray.filter(option => {
                let splitValue = option.text.split("/");
                let downstream = parseInt(splitValue[0]);
                return downstream <= remainingCapacity;
              });
            }
          }
        }
      } catch (e) {
        // Error in getBandwidthFibreIncludingThreshold
      }
      return bandwidthArray;
    }
  },
  watch: {
    showContractTerm(show) {
      if (!show) {
        this.nbnOrder.contractTerm = null;
        this.emitData();
      }
    }
  },
  computed: {
    showContractTerm() {
      if (this.isEE) {
        return false;
      }
      const accountNumber = this.isOriginal
        ? this.nbnOrder.wholesalerAccountNumber || this.wholesalerAccount
        : this.wholesalerAccount;
      return wholesalerUsesContractTerm(this.wholesalers, accountNumber);
    },
    isNCAS() {
      let vm = this;
      if (
        vm.productType != null &&
        (vm.productType === "FTTB" ||
          vm.productType === "FTTC" ||
          vm.productType === "FTTN")
      ) {
        return true;
      } else {
        return false;
      }
    },
    isEE() {
      let vm = this;
      if (vm.productType != null && vm.productType === "Enterprise Ethernet") {
        return true;
      } else {
        return false;
      }
    },
    getBandwidth() {
      let vm = this;
      let bandwidth = [];

      var productType = vm.isOriginal
        ? vm.nbnOrder.productType
        : vm.productType;
      if (!productType) productType = vm.nbnOrder.productType;

      if (productType === "FTTB" || productType === "FTTN") {
        if (vm.isOriginal) {
          bandwidth = vm.NCASBandwidthProfile;
        } else {
          bandwidth = vm.NCASBandwidthProfile.filter(
            option => option.value !== "D25-100_U5-20_Mbps_TC4_P"
          );
        }
      } else if (productType === "Fixed Wireless") {
        bandwidth = vm.NWASBandwidthProfile;
      } else if (productType === "HFC") {
        bandwidth = vm.NHASBandwidthProfile;
      } else if (productType === "FTTC") {
        if (vm.isOriginal) {
          bandwidth = vm.FTTCBandwidthProfile;
        } else {
          bandwidth = vm.FTTCBandwidthProfile.filter(
            option => option.value !== "D25-100_U5-40_Mbps_TC4_P"
          );
        }
      } else if (productType === "Fibre" || productType === "FTTP") {
        if (vm.isOriginal) {
          bandwidth = vm.NFASBandwidthProfile;
        } else {
          bandwidth = vm.NFASBandwidthProfile.filter(
            option =>
              option.value !== "D25-50_U5-20_Mbps_TC4_P" &&
              option.value !== "D25-100_U5-40_Mbps_TC4_P"
          );
        }

        const selectedValue = vm.nbnOrder.bandwidthProfile;
        const hasSelected =
          selectedValue &&
          bandwidth.some(b => b.value === selectedValue);

        if(vm.featureFlags?.sog8737){
          if(vm.nbnOrder.orderType?.toLowerCase() !== "transfer") {
            if (!hasSelected) {
              bandwidth = vm.getBandwidthFibreIncludingThreshold(bandwidth);
            }
          }
        } else {
          if (!hasSelected) {
            bandwidth = vm.getBandwidthFibreIncludingThreshold(bandwidth);
          }
        }
      }
      if (vm.nbnOrder.nbnAssureRequired == "Yes") {
        bandwidth = bandwidth.filter(x =>
          NBN_ASSURE_ALLOWED_SPEED.includes(x.text)
        );
      }

      bandwidth = bandwidth.map(item => ({
        ...item,
        disabled: item.disabled === true,
        obsolete: item.obsolete === true
      }));

      // SOG-8559: For transfer orders, disable bandwidth options exceeding NTD capacity
      // speedTiersSupported only lists named tiers (Home Fast, Home Superfast, etc.)
      // Items with technical codes (D100_U40_Mbps_TC4_P) are always within capacity
      if (vm.nbnOrder.orderType?.toLowerCase() === "transfer" && !vm.isOriginal) {
        try {
          const resource = vm.sqNbnResult?.sq?.siteRestriction?.supportingResource;
          if (Array.isArray(resource) && resource.length > 0) {
            const selectedNtd = resource.find(x => x?.id === vm.nbnOrder.ntdId) ?? resource[0];
            const tiers = selectedNtd?.speedTiersSupported;
            if (Array.isArray(tiers) && tiers.length > 0) {
              const allTierNames = tiers.map(t => t.featureType);
              const supportedTierNames = tiers.filter(t => t.supported).map(t => t.featureType);
              bandwidth = bandwidth.map(item => {
                const isNamedTier = allTierNames.includes(item.value);
                const isSupported = supportedTierNames.includes(item.value);
                return {
                  ...item,
                  disabled: item.disabled || (isNamedTier && !isSupported)
                };
              });
            }
          }
        } catch (e) {
          // Fall through with unfiltered bandwidth on error
        }
      }

      return bandwidth;
    },
    FTTCBandwidthProfile() {
      let vm = this;
      return getFTTCBandwidthProfiles(vm.featureFlags.sog6028);
    }
  }
};
</script>

<style scoped></style>
